/**
 * @file  modal/index.tsx
 * @description modal element
 *
 * @example <Title level=[1,2,3,4,5] />
 *
 * @author dlima (dlima-electron)
 *
 */
import React from 'react';
import './styles.scss';
import * as S from './styles';

/**
 * @description layout styled element
 *
 * @param Props
 */
const Modal = ({
  title,
  onOk,
  okText,
  cancelText,
  onCancel,
  visible,
  children,
  closable,
  className
}: S.Props): JSX.Element => (
  <S.Modal
    className={`modal-confirm ${className}`}
    title={title}
    onOk={onOk}
    okText={okText}
    cancelText={cancelText}
    onCancel={onCancel}
    open={visible}
    okButtonProps={{
      className: `primary ${onOk === undefined ? 'hidden' : ''}`
    }}
    cancelButtonProps={{
      className: `secondary ${onCancel === undefined ? 'hidden' : ''}`
    }}
    closable={closable ?? true}
  >
    {children}
  </S.Modal>
);

export default Modal;
